import { render, staticRenderFns } from "./AppAssessmentsView.vue?vue&type=template&id=039cdf4c"
import script from "./AppAssessmentsView.vue?vue&type=script&lang=ts"
export * from "./AppAssessmentsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports